interface CalculatePercentage {
  (value?: string | number, total?: string | number, decimals?: number): number;
}


/**
 * @description Safely calculate the percentage of a value compared to a total.
 * * **value** {string, number, undefined} - The value to calculate the percentage for.
 * * **total** {string, number, undefined} - The total to calculate the percentage for.
 * * **decimals** {number, undefined} - The number of decimals to return. Default 0.
 *
 * @example
 * calculatePercentage(10, 100) // 10
 * calculatePercentage(10, 100, 2) // 10.00
 * calculatePercentage(10, 0) // 0
 * calculatePercentage(0, 100) // 0
 * calculatePercentage(0, 0) // 0
 * calculatePercentage(0, 0, 2) // 0.00
 * calculatePercentage() // 0
 */
export const calculatePercentage: CalculatePercentage = (value, total, decimals = 0) => {
  // 1: No values. 2: Cannot divide by 0
  if ((!value || !total) || total === 0) return 0;

  // Safe the division
  const safeValue = Number(value) || 0;
  const safeTotal = Number(total) || 0;

  // Return the percentage. Check again against 0 to avoid NaN
  return safeTotal !== 0 ? Number(((safeValue / safeTotal) * 100).toFixed(decimals)) : 0;
};
